export default "__VITE_ASSET__BpANyTCH__"